import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { Image, Grid, Row, Col } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import buildUrl from 'build-url-ts';
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import { localizedStrings } from 'src/localization/index.jsx';
import { OutlookSideBar } from './OutlookSideBar';
import { OutlookOnboardingView } from './OutlookOnboardingView';
import _ from 'lodash';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

class SalesforceView extends React.Component {
    static contextTypes = {
        store: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state={
          deleteConfirmation: false,
          showIntergrationOnboarding: false,
        }
        this.handleAuthenticate = this.handleAuthenticate.bind(this);
        this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
        this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
        this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);
        this.disableScroll = this.disableScroll.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.localizedIntegrations = localizedStrings.components.integrations;
        this.localizedOutlook = localizedStrings.components.integrations.outlook;
        this.localizedCommons = localizedStrings.commons;
        this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
    }

    componentDidMount() {
        if(shouldFetchIntegrations(this.props.integrations)) {
            this.props.fetchIntegrations();
          }
        const integration = localizedStrings.constants.integrationsOnboarding.integrations.outlook;
        const sections = integration.sections;
          this.setState({
            selectedTab: sections[0].id,
            showIntergrationOnboarding: !_.get(this.props, "integration", true),
          })
    }

    _handleDeactivateClicked() {
      this.setState({
        deleteConfirmation: true
      })
    }
    showIntergrationOnboarding(){
        this.setState({
          showIntergrationOnboarding: !this.state.showIntergrationOnboarding
        })
      }
    disableScroll(value){
        this.setState({
          isScrollDisabled: value
        })
    }

    handleScroll = (e) => {

      if(this.state.isScrollDisabled){
        return;
      }
  
      const integration = localizedStrings.constants.integrationsOnboarding.integrations.outlook;
      const sections = integration.sections;
  
      if(sections) { 
        const buffer = 25;
        let selectedTabIndex = 0;
  
        for (let i = 0; i < sections.length; i++) {
  
        const sectionId = sections[i].id;
        const element = document.getElementById(sectionId);
  
        if (element) {
          const { top } = element.getBoundingClientRect();
          const position = top;
  
          if ( e.target.scrollTop >= position - buffer) {
            selectedTabIndex = i;
          } 
        }
      }
  
      this.setState({
        selectedTab: sections[selectedTabIndex].id,
      })
    }};

    render() {
      var isAuthenticated = false;

      if (this.props.integration && _.get(this.props, 'integration.state.code') === "ok" && !this.props.error) {
          isAuthenticated = true; 
        }
        
      var isTokenExpired = _.get(this.props, 'integration.state.code') === "auth_error";
      
      return (
        // <Grid className={styles.content} fluid>
        <div>
          <Row className={styles.row}>
            <Col md={3} className={styles.left}>
              <OutlookSideBar
                integration={this.props.integration}
                handleAuthenticate={this.handleAuthenticate}
                showIntergrationOnboarding={this.showIntergrationOnboarding}
                _handleDeactivateClicked={this._handleDeactivateClicked}
                deactivating={this.props.deactivating}
                isAuthenticated={isAuthenticated}
                authenticating={this.props.authenticating}
                isTokenExpired={isTokenExpired}
                navigate={this.props.navigate}
                isShowIntegrationOnboarding={this.state.showIntergrationOnboarding}
              />
            </Col>
            <Col md={9} id="right" className={styles.right} onScroll={(e) => this.handleScroll(e)}>
             {this.props.isIntegrationLoading && (
             <p className={styles.isIntegrationLoading}>{this.localizedCommons.loading.loading}...</p>)}
             {!this.props.isIntegrationLoading && (!_.get(this.props, "integration") || this.state.showIntergrationOnboarding) && (
              <OutlookOnboardingView
                selectedTab={this.state.selectedTab}
                disableScroll={this.disableScroll}
              />
            )}
            {!_.get(this.props, "integration") && !isAuthenticated && this.state.showIntergrationOnboarding && (
              <div className={styles.authorize}>
                <h3>{this.localizedGmail.activate.title}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      this.localizedGmail.activate.sub_text
                    ),
                  }}
                />
              </div>
            )}
              {_.get(this.props, "integration") && !isAuthenticated && !this.state.showIntergrationOnboarding &&  (
                <div className={styles.authorize}>
                  <h2>{this.localizedOutlook.expired.title}</h2>
                  <p>{this.localizedOutlook.expired.re_authenticate}</p>
                </div>
              )}
              {!this.state.showIntergrationOnboarding && _.get(this.props, "integration") && isAuthenticated && (
                  <div className={styles.authFinish}>
                    <h3 className={styles.secondLine}>{this.localizedOutlook.active.title}
                    <h4>{this.localizedOutlook.active.for_email}: <i>{this.props.integration.configuration.email}</i></h4>
                    </h3>
                  </div>
                )}
            </Col>
          </Row>
          <DeactivateIntegrationContainer
            name={this.localizedOutlook.title}
            type="outlook"
            message={localizedStrings.formatString(
              this.localizedOutlook.deactivate_slider.sub_text,
              {
                email:
                  (this.props.integration &&
                    this.props.integration.configuration.email) ||
                  "",
              }
            )}
            show={this.state.deleteConfirmation}
            onCancel={() => {
              this.setState({
                deleteConfirmation: false,
              });
            }}
          />
        </div>
      );
    }

    handleAuthenticate() {
        //Calculate Position
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

        var w = 0.8 * width;
        var h = 0.8 * height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;

        const url = buildUrl(apiUrl, {
            path: `/api/2.0/integrations/outlook/authorize`
        })

        var newWindow = window.open(url, `Authorize outlook Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (newWindow.focus) {
            newWindow.focus();
        }

        //Attaching message event listner
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent, this.handleAuthenticateEvent, false);
        return false;
    }

    handleAuthenticateEvent(e) {

        //Removing message event listner
        var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
        var deEventer = window[detachEventMethod];
        var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

        if (e.data.type == 'OUTLOOK_AUTHORIZATION_SUCCESS') {
            var code = e.data.payload.code;
            var state = e.data.payload.state;
            var error = e.data.payload.error;
            this.props.trackAdoptionMetricsForPluginConnectedEvent('Outlook')
            if (!error) {
                this.props.authenticateAccount(code, 'outlook');
            }

            deEventer(messageEvent, this.handleAuthenticateEvent, false);
        }
    }
}

export default SalesforceView;